import { useTranslation } from 'react-i18next';
import { useGetCustomService } from 'hooks/rest/useGetCustomService';

const STALE_TIME = 5 * 60 * 1000;
const GC_TIME = 10 * 60 * 1000;

export const GENERAL_DOCUMENTS_QUERY_API = 'getGeneralDocuments';

export const useGeneralDocuments = () => {
    const { i18n: { language } } = useTranslation();

    return useGetCustomService({
        service: 'customDocumentsService',
        api: GENERAL_DOCUMENTS_QUERY_API,
        payload: { language },
        enabled: true,
        staleTime: STALE_TIME,
        gcTime: GC_TIME,
    });
};
